import React from 'react';
import { materiahAiIcon } from '../../config_and_helpers/config';
import './AiChatStyle.css';

/**
 * Floating Materiah AI entry control using the design team icon.
 * Top-right on desktop; bottom-right on narrow viewports so it does not
 * cover the navbar hamburger toggle.
 *
 * @param {Object} props
 * @param {function} props.onClick - Opens the chat panel.
 * @returns {JSX.Element}
 */
const AiChatFab = ({ onClick }) => (
  <button
    type="button"
    className="ai-chat-fab"
    onClick={onClick}
    aria-label="Open Materiah AI assistant"
    title="Materiah AI"
  >
    <img
      src={materiahAiIcon}
      alt=""
      className="ai-chat-fab__icon"
      width={64}
      height={64}
      draggable={false}
    />
  </button>
);

export default AiChatFab;
